<template>
  <div
    v-if="ready"
    class="columns is-centered"
  >
    <div class="column is-10 is-tablet-full">
      <div class="main-content section">
        <h2 class="title is-4 has-text-centered">
          Welcome to the City of Philadelphia's<br> Financial Disclosure System
        </h2>
        <div
          v-if="disclaimers && disclaimers[1]"
          class="columns"
        >
          <div class="column">
            <callout type="danger">
              <div v-html="disclaimers[1].description" />
            </callout>
          </div>
        </div>
        <p>
          The Financial Disclosure System allows you to file annual financial disclosure statements - City of Philadelphia Statement of Financial Interests, Mayor's Executive Order Financial Disclosure Statement or the Commonwealth of PA Statement of Financial Interests. Check with your department administrator or legal counsel to determine if you are required to complete any or all of these statements.
        </p>
        <login-form
          :loading="loading"
          @login="login($event)"
        />
        <div class="columns">
          <div class="column">
            <h3 class="title is-size-5">
              Need help? contact the Board of Ethics at <a href="tel:215-686-9450" target="_blank">215-686-9450</a> or <a href="mailto:FinancialDisclosures@phila.gov">FinancialDisclosures@phila.gov</a>
            </h3>
            <p>
              Please be advised that statements of financial interest filed by City of Philadelphia officials and employees are available for public inspection and copying in the Records Department and may be posted online. If you are concerned that disclosure of information submitted would be reasonably likely to pose a specific threat to your personal security or the personal security of an individual named on your form, please submit speciﬁc details regarding your concern to: <a href="mailto:financialdisclosureprivacy@phila.gov">financialdisclosureprivacy@phila.gov</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginForm from '@/components/LoginForm2';
import { Callout } from '@phila/phila-ui';
export default {
  name: "Login",
  components: {
    LoginForm,
    Callout,
  },
  data() {
    return {
      html: "<a href='#'>my link</a>",
      ready: false,
      loading: false,
      loginInfo: {
        username: '',
        password: '',
      },
      mainElement: null,
      elementsToSkip: [],
      successValidateEmail: null,
    };
  },
  computed: {
    disclaimers () {
      return this.$store.getters[ 'admin/activeControlValues' ]('disclaimer');
    },
  },
  async created () {
    await this.initialFetch();
    this.ready = true;
  },
  methods: {
    async initialFetch () {
      let promises = [];
      promises.push(this.$store.dispatch('admin/getControlValue', 'disclaimer'));
      return Promise.all(promises);
    },
    async login(event) {
      this.loginInfo = event;
      this.loading = true;
      let session = await this.$store.dispatch('login/startSession', this.loginInfo);
      if (!session) {
        this.loading = false;
      }
    },
  },
};
</script>
